import reactStringReplace from "react-string-replace";

import { cn } from "@/lib/utils";

interface HeadingWithHighlightProps {
  as?: "h1" | "h2";
  className?: string;
  title: string;
}

export default function HeadingWithHighlight({
  as = "h2",
  className,
  title,
}: HeadingWithHighlightProps) {
  const Comp = as;

  return (
    <Comp
      className={cn(
        "text-center font-semibold text-28/[1.5em] md:text-48/[1.25em]",
        className
      )}
    >
      {reactStringReplace(title, /\*\*(.*)\*\*/g, (match, index) => (
        <span
          className="bg-linear-to-r from-4% from-cyan to-41% to-cerulean bg-clip-text text-transparent"
          key={index}
        >
          {match}
        </span>
      ))}
    </Comp>
  );
}
